import CloseIcon from '@mui/icons-material/CloseOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import type {ReactNode} from 'react';

import {AttentionIcon20} from '../icons/AttentionIcon';
import css from './Alert.module.css';

export type AlertSeverity = 'error' | 'warning' | 'info';

interface AlertProps {
	severity?: AlertSeverity;
	children?: ReactNode;
	className?: string;
	/**
	 * Крестик справа. Есть не у всякого сообщения: ошибка запроса живёт, пока
	 * жив её cause, а вот подсказки человек закрывает сам (SKS-761).
	 */
	onClose?: () => void;
}

const ICONS = {
	error: ErrorOutlineIcon,
	info: InfoOutlinedIcon,
};

/**
 * Плашка с сообщением. Native div, а не MuiAlert — по той же причине, что и у
 * Button: вся палитра лежит в токенах --danger-* / --attention-* / --brand-*,
 * и переопределять её поверх MUI дороже, чем написать разметку.
 */
export function Alert({severity = 'info', children, className, onClose}: AlertProps) {
	/*
	 * Warning-глиф — макетный AttentionIcon20 (SKS-380): цвет и размер зашиты
	 * в самой иконке, своего MUI-пропа fontSize у неё нет, поэтому не в словаре
	 * ICONS, а отдельной веткой ниже.
	 */
	const Icon = severity === 'warning' ? null : ICONS[severity];

	return (
		<div className={[css.root, css[severity], className].filter(Boolean).join(' ')} role="alert">
			{Icon ? (
				<Icon className={css.icon} fontSize="small" />
			) : (
				<AttentionIcon20 className={css.icon} />
			)}
			<div className={css.body}>{children}</div>
			{onClose ? (
				<button type="button" className={css.close} aria-label="Скрыть" onClick={onClose}>
					<CloseIcon fontSize="inherit" />
				</button>
			) : null}
		</div>
	);
}
